import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DfGalleryComponent } from './df-gallery.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '../../pipes';

@NgModule({
  declarations: [DfGalleryComponent],
  imports: [
    CommonModule,
    PipesModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSnackBarModule,
    MatChipsModule,
    MatButtonModule,
    MatIconModule,
  ],
  exports: [DfGalleryComponent],
})
export class DfGalleryModule {}
